module.exports = __webpack_public_path__ + "fonts/notosans-semibold-web.60ce054.ttf";